export default __webpack_public_path__ + "static/maneti dashboard-0f626e0f6de9f1ecc1502a4b6fc56334.mp4";